/*
 * @Author: liyifan 
 * @Date: 2025-11-06 16:28:43 
 * @Last Modified by: liyifan
 * @Last Modified time: 2026-01-21 14:16:34
 */

import { shopifyCartAdd } from '@utils/api'

if (!customElements.get("v5-pdp-scene-compare")) {
  class V5PdpSceneCompare extends HTMLElement {
    constructor() {
      super();
      this.DOM = {
        addToCartList: [],
      };
      this.isMobile = window.innerWidth < 1024;
      this._handlers = new Map();
      
    }
    connectedCallback() {
        this.DOM.addToCartList = this.querySelectorAll("[compare-add-to-cart]");
        this.size = Number(this.getAttribute('data-size'))
        this.bindEvents();
        // 在PC端大于3个执行swiper， 在移动端大于1个执行swiper
        if (this.size > 3 && !this.isMobile || this.size > 1 && this.isMobile) {
          this.initSwiper()
        }
    }
    disconnectedCallback() {
      this.unbindEvents();
    }
    bindEvents() {
      const handler = (e) => {
        const btn = e.target.closest("[compare-add-to-cart]");
        if (btn) this.addToCart(btn);
      };
      this.addEventListener("click", handler);
      this._handlers.set(this, handler);
    }
    unbindEvents() {
      const handler = this._handlers.get(this);
      if (handler) this.removeEventListener("click", handler);
      this._handlers.clear();
    }
    async addToCart(el) {
      el.classList.add('loading')
      const cart = document.querySelector("cart-notification") || document.querySelector("cart-drawer");
      try {
        const { id, spu_title, title } = el.dataset;
        const items = [{ id, quantity: 1 }]
        const res = await shopifyCartAdd({items});
        if (cart?.renderContents) {
          cart.renderContents(res);
        } else {
          window.location.href = "/cart";
        }
        const gaParams = {
          product_spu_name: spu_title,
          module: "ProductsCompare_1",
          position: title,
          button_name: "AddToCart",
        }
        gaPushDataLayer('5.0_products_details_page_user_clicks', gaParams);
      } catch (e) {
        e?.statusText && pushErrorMessage(e.statusText);
      } finally {
        el.classList.remove('loading')
        cart?.classList.contains("is-empty") && cart.classList.remove("is-empty");
      }
    }
    initSwiper() {
      const swiperEl = this.querySelector(".v5-pdp-scene-compare-swiper");
      if (!swiperEl) return;
      new Swiper(swiperEl, {
        slidesPerView: this.isMobile ? 1.26 : 3,
        spaceBetween: 24,
        loop: true,
        simulateTouch: true,
        touchStartPreventDefault: false,
        passiveListeners: true,
        navigation: this.isMobile ? false : {
          nextEl: this.querySelector(".v5-icon-arrow-right"),
          prevEl: this.querySelector(".v5-icon-arrow-left"),
        },
      });
    }
  }
  customElements.define("v5-pdp-scene-compare", V5PdpSceneCompare);
}
